var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"symbol",style:(`width: ${_vm.width}px; height: ${_vm.height}px`),attrs:{"src":require("../assets/symbol.svg"),"alt":"Vale Saúde Sempre"}})
}
var staticRenderFns = []

export { render, staticRenderFns }